module.exports = __webpack_public_path__ + "static/media/logo-c-64.cbdc7dae.png";